import { z } from "zod";

/** The field kinds an admin can use when defining a content type. */
export const FIELD_KINDS = [
  "text",
  "richtext",
  "number",
  "boolean",
  "date",
  "media",
  "reference",
] as const;

export const fieldKindSchema = z.enum(FIELD_KINDS);
export type FieldKind = z.infer<typeof fieldKindSchema>;

/** Machine key for a field: snake_case, starts with a letter. */
export const fieldKeySchema = z
  .string()
  .regex(/^[a-z][a-z0-9_]*$/, "must be snake_case starting with a letter")
  .max(64);

/** Per-field configuration. Only the keys relevant to the field kind are used. */
export const fieldConfigSchema = z
  .object({
    // text / richtext
    minLength: z.number().int().nonnegative().optional(),
    maxLength: z.number().int().positive().optional(),
    // number
    min: z.number().optional(),
    max: z.number().optional(),
    integer: z.boolean().optional(),
    // media / reference
    multiple: z.boolean().optional(),
    // reference: the content type id this field points at
    refTypeId: z.string().optional(),
  })
  .strict();
export type FieldConfig = z.infer<typeof fieldConfigSchema>;

export const fieldDefSchema = z
  .object({
    key: fieldKeySchema,
    label: z.string().min(1).max(120),
    kind: fieldKindSchema,
    required: z.boolean().default(false),
    config: fieldConfigSchema.default({}),
  })
  .strict();
export type FieldDef = z.infer<typeof fieldDefSchema>;
